export default "__VITE_ASSET__c5c94b89__"